import * as React from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { PickupStatsCategories } from '../../../../helpers';
import { IAdHocRoundBoxScoreDto } from '../../../../WorldDoomLeague';
import AdHocMatchOverallPickupsTable from './AdHocMatchOverallPickupsTable';

interface AdHocMatchOverallPickupsTabsViewProps {
    category: PickupStatsCategories;
    finalBoxScore: IAdHocRoundBoxScoreDto;
    categoriesObject: PickupStatsCategories[];
};

const AdHocMatchOverallPickupsTabsView = (props: AdHocMatchOverallPickupsTabsViewProps) => {

    return (
        <React.Fragment>
            <TabContent activeTab={props.category}>
                {props.categoriesObject && props.categoriesObject.map((s, idx) => (
                    <TabPane tabId={s} key={idx}>
                        <AdHocMatchOverallPickupsTable activeCategory={props.category} finalBoxScore={props.finalBoxScore} key={idx} />
                    </TabPane>
                    ))}
            </TabContent>
        </React.Fragment>);
};

export default AdHocMatchOverallPickupsTabsView;